import { render, staticRenderFns } from "./BranchView.vue?vue&type=template&id=10393388&"
import script from "./BranchView.vue?vue&type=script&lang=js&"
export * from "./BranchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports